import { useQuery } from "@tanstack/react-query";

import { JOBS_POLLING_INTERVAL_MS } from "../../../../constants";
import { useCrmEnrichmentJobsDataSync } from "../../../../hooks/useCrmEnrichmentJobsDataSync";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

type Options = {
    enabled?: boolean;
    polling?: boolean;
};

const useSfEnrichmentJobsQuery = ({ enabled = true, polling = false }: Options = {}) => {
    const queryOptions = polling
        ? {
              refetchInterval: JOBS_POLLING_INTERVAL_MS,
              refetchIntervalInBackground: false,
              refetchOnMount: "always" as const,
              staleTime: 0,
              gcTime: 0,
          }
        : {};

    const query = useQuery({
        enabled,
        queryKey: salesforceEnrichmentQueryKeys.jobs(),
        queryFn({ signal }) {
            return sfEnrichmentApiService.getJobs({
                cancellation: signal,
            });
        },
        ...queryOptions,
    });

    useCrmEnrichmentJobsDataSync(query.data, salesforceEnrichmentQueryKeys);

    return query;
};

export default useSfEnrichmentJobsQuery;
